import { render } from "./PromotionShowComponent.vue?vue&type=template&id=7bc2c441"
import script from "./PromotionShowComponent.vue?vue&type=script&lang=js"
export * from "./PromotionShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/promotions/PromotionShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bc2c441"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bc2c441', __exports__)) {
    api.reload('7bc2c441', __exports__)
  }
  
  module.hot.accept("./PromotionShowComponent.vue?vue&type=template&id=7bc2c441", () => {
    api.rerender('7bc2c441', render)
  })

}


export default __exports__